import { getCookie } from "./util/general_util";
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let log_expandedCamp_intervalID:NodeJS.Timer|null=null;
let log_campPageView_intervalID:NodeJS.Timer|null=null;
let log_genieTripView_intervalID:NodeJS.Timer|null=null;

declare global {
	interface Window {
		appInsights:ApplicationInsights|null;
	}
};



function send_log(eventName:string, properties:any) {
    if (window.appInsights !== null && window.appInsights !== undefined) {
        properties["uID"] = getCookie("AGanalytics");
        window.appInsights.trackEvent({
            name: eventName,
            properties: properties
        });
    };
};

function log_expandedCamp_view(campID:number) {
    send_log("expandedCamp",{
        campID: campID,
        viewID: log_expandedCamp_intervalID
    });
};

export function start_expandedCamp_log(campID:number) {
    log_expandedCamp_intervalID = setInterval(log_expandedCamp_view, 5000, campID);
    log_expandedCamp_view(campID);
};

export function stop_expandedCamp_log() {
    if (log_expandedCamp_intervalID != null) {
        clearInterval(log_expandedCamp_intervalID);
        log_expandedCamp_intervalID = null;
    };
};

export function log_login(email:string) {
    send_log("login",{
        email:email
    });
};

export function log_openRoadsClick() {
    send_log("openRoadsClick",{});
}

function log_campPageView(campID:number) {
    send_log("campPage", {
        campID:campID,
        viewID: log_campPageView_intervalID
    });
};

export function start_campPage_log(campID:number) {
    log_campPageView_intervalID = setInterval(log_campPageView, 30000, campID);
    log_campPageView(campID);
};

export function stop_campPage_log() {
    if (log_campPageView_intervalID != null) {
        clearInterval(log_campPageView_intervalID);
        log_campPageView_intervalID = null;
    };
};

export function addStay_log(campID:number) {
    send_log("addStay",{campID:campID}
    );
};

function log_genieTripView(trip_url_ext:string) {
    send_log("genieTrip", {
        trip_url_ext:trip_url_ext,
        viewID:log_genieTripView_intervalID
    });
};

export function start_genieTrip_log(trip_url_ext:string) {
    log_genieTripView_intervalID = setInterval(log_genieTripView, 30000, trip_url_ext);
    log_genieTripView(trip_url_ext);
};

export function stop_genieTrip_log() {
    if (log_genieTripView_intervalID != null) {
        clearInterval(log_genieTripView_intervalID);
        log_genieTripView_intervalID = null;
    };
};

export function takeGenieTrip_log(trip_url_ext:string) {
    send_log("takeGenieTrip", {trip_url_ext: trip_url_ext});
};

export function autofill_click_log(query_type:string,query_val:string) {
    send_log("autofill_click",{
        type: query_type,
        val: query_val
    });
};

export function freeForm_search_log(query:string) {
    send_log("freeForm_search",{
        query:query
    });
};

export function addFilter_log(amenityOrActivity:"amenity"|"activity"|"s2nTP"|"s2nCS", filterBy: string) {
    send_log("cg_filter", {
        filterType: amenityOrActivity,
        filterBy: filterBy
    });
};

export function sponsoredStaySuggestion_click_log(searchId:string, campId:number, type:string) {
    send_log("sponsoredSearchClick_campPopup", {
        "id": searchId,
        "campID": campId,
        "type": type
    })
};

export function sponsoredStaySuggestion_impression_log(searchId:string, sponsoredCamps_campIDs:Array<number>, clusterName:string, clusterLoc:{"latitude":number,"longitude":number}) {
    send_log("sponsoredSearchEvent", {
        "id": searchId,
        "type": "trip_suggestedStays",
        "tripClusterLat": clusterLoc.latitude,
        "tripClusterLon": clusterLoc.longitude,
        "tripClusterName": clusterName,
        "result_campIDs": sponsoredCamps_campIDs
    });
};

export function rvShare_click_log(rvId:number, link:string) {
    send_log("rvShare_click", {
        rvId: rvId,
        link: link
    });
};

export function frvt_click_log(tourName:string, tourDate:string) {
    send_log("frvt_tour_click", {
        tourName:tourName,
        tourDate:tourDate
    });
};

export function ag_ad_impression_log(ad_id:string) {
    send_log("ag_ad_impression", {
        "ad-id": ad_id
    });
};

export function ag_ad_click_log(ad_id:string) {
    send_log("ag_ad_click", {
        "ad-id": ad_id
    })
};